import { OLButton } from "OLButton";
import { SelectInput } from "components/FormControls/Select/Select";
import { ReactComponent as ChevronLeftIcon } from "components/Icons/chevron-left.svg";
import { useMessage } from "hooks/intl";
import { SelectedFilter } from "types/filters";
import { Conditions } from "../FilterBase/Conditions";
import { Values } from "../FilterBase/Values";
import { useStyles } from "../styles";

interface Props {
  editedFilter: { filter: SelectedFilter | null; index: number | null };
  onClose: () => void;
  properties: SelectedFilter[];
  selectedFilters: SelectedFilter[];
  replace: (index: number, filter: SelectedFilter) => void;
  saveFilter: () => void;
  setEditedFilter: ({
    filter,
    index,
  }: {
    filter: SelectedFilter;
    index: number;
  }) => void;
}

export const Filter = ({
  editedFilter,
  onClose,
  properties,
  selectedFilters,
  replace,
  saveFilter,
  setEditedFilter,
}: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <>
      <OLButton
        className={`${classes.sidebarBtn} ${classes.backBtn}`}
        startIcon={<ChevronLeftIcon />}
        onClick={onClose}
      >
        {message({ id: "back" })}
      </OLButton>
      <div className={classes.filterSidebar}>
        <SelectInput
          name={`filters.[${editedFilter.index}].query`}
          items={properties.map((singleFilter) => ({
            label: singleFilter.label,
            id: singleFilter.query,
            disabled: !!selectedFilters.find(
              (selectedFilter) => selectedFilter.query === singleFilter.query,
            ),
          }))}
          onChange={(_e, newFilterQuery) => {
            const newFilter = properties.find(
              (filter) => filter.query === newFilterQuery,
            );
            replace(editedFilter.index as number, newFilter as SelectedFilter);
          }}
          isCustomSelect
        />
        <Conditions
          filter={editedFilter.filter as SelectedFilter}
          index={editedFilter.index as number}
          size="medium"
          onChange={(_e, value) => {
            setEditedFilter({
              filter: {
                ...editedFilter.filter,
                condition: value,
              } as SelectedFilter,
              index: editedFilter.index as number,
            });
          }}
        />
        <Values
          filter={editedFilter.filter as SelectedFilter}
          index={editedFilter.index as number}
          size="medium"
        />
        <OLButton
          className={classes.saveFilter}
          variant="contained"
          onClick={saveFilter}
        >
          {message({ id: "saveFilter" })}
        </OLButton>
      </div>
    </>
  );
};
